import React from 'react';
import { FlexRow } from '@make-software/cspr-design';
import { BodyText } from '@block-explorer/ui';
import { Deploy } from '@block-explorer/entities';
import Skeleton from 'react-loading-skeleton';
import { DefaultActionMessage, TransferActionMessage } from './action-messages';
import {
  ExecutionTypesMap,
  isTransferDeploy,
  isWASMTransaction,
} from '../../utils/contract.tsx';

export interface TableDataEntryPointProps {
  deployData: Deploy;
  loading: boolean;
  showContractHash?: boolean;
  showOnlyActionName?: boolean;
  callerPublicKey?: string;
  recipientPublicKey?: string;
  isTransfer?: boolean;
}

export const TableDataEntryPoint = ({
  deployData,
  loading,
}: TableDataEntryPointProps) => {
  const { executionTypeId, contractPackage, contractHash, entryPoint } =
    deployData;

  const deployType = ExecutionTypesMap[executionTypeId];
  const isWasm = isWASMTransaction(executionTypeId); //deployType !== WASM_DEPLOY;
  const isTransfer = isTransferDeploy(contractHash, entryPoint?.name);

  if (loading || !deployData) {
    return (
      <BodyText size={3}>
        <Skeleton />
      </BodyText>
    );
  }

  if (isTransfer) {
    return <TransferActionMessage deploy={deployData} showOnlyActionName />;
  }

  if (isWasm) {
    return (
      <FlexRow align={'baseline'} itemsSpacing={4}>
        <BodyText monotype size={3}>
          {deployType}
        </BodyText>
      </FlexRow>
    );
  }

  if (!contractPackage) {
    return (
      <BodyText monotype size={3}>
        N/A
      </BodyText>
    );
  }

  return <DefaultActionMessage deploy={deployData} hideContractIdentifier />;
};
